import { ICountryServiceMock } from "./country.types";

export const mockCountryService = (): ICountryServiceMock => ({
  getCountries: jest.fn(),
  getConfig: jest.fn(),
  getCommodities: jest.fn(),
  getCountryConfigByCode: jest.fn(),
  saveCountryConfig: jest.fn(),
});
